import React from 'react';
import { Card, CardContent } from "../../tailwind/card";
import { SignalHigh } from "lucide-react";

export const QualityRating = ({ rating = "High" }) => {
  const getColor = (r) => {
    switch(r) {
      case 'High': return 'text-green-600 bg-green-50 dark:bg-green-900/20 dark:text-green-400 border-green-100 dark:border-green-900';
      case 'Medium': return 'text-amber-600 bg-amber-50 dark:bg-amber-900/20 dark:text-amber-400 border-amber-100 dark:border-amber-900';
      case 'UNKNOWN': return 'text-gray-600 bg-gray-50 dark:bg-gray-900/20 dark:text-gray-400 border-gray-100 dark:border-gray-900';
      default: return 'text-red-600 bg-red-50 dark:bg-red-900/20 dark:text-red-400 border-red-100 dark:border-red-900';
    }
  };

  const theme = getColor(rating);

  const label = rating === 'UNKNOWN' ? '-' : rating;

  return (
    <Card className={`border ${theme.split(' ')[3]} ${theme.split(' ')[1]}`}>
      <CardContent className="p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className={`font-semibold ${rating === 'High' ? 'text-green-900 dark:text-green-100' : rating === 'UNKNOWN' ? 'text-gray-700 dark:text-gray-200' : 'text-gray-900 dark:text-gray-100'}`}>Quality Rating</h3>
          <SignalHigh className={`h-5 w-5 ${rating === 'High' ? 'text-green-600 dark:text-green-400' : rating === 'UNKNOWN' ? 'text-gray-500 dark:text-gray-400' : 'text-amber-600 dark:text-amber-400'}`} />
        </div>
        
        <div className="flex items-center gap-3">
          <div className="flex gap-1">
            <div className={`h-8 w-3 rounded-sm ${rating === 'High' ? 'bg-green-500' : rating === 'UNKNOWN' ? 'bg-gray-200 dark:bg-gray-700' : 'bg-green-200 dark:bg-green-900'}`} />
            <div className={`h-8 w-3 rounded-sm ${rating === 'Medium' ? 'bg-amber-500' : rating === 'UNKNOWN' ? 'bg-gray-200 dark:bg-gray-700' : 'bg-gray-200 dark:bg-gray-700'}`} />
            <div className={`h-8 w-3 rounded-sm ${rating === 'Low' ? 'bg-red-500' : rating === 'UNKNOWN' ? 'bg-gray-200 dark:bg-gray-700' : 'bg-gray-200 dark:bg-gray-700'}`} />
          </div>
          <div>
            <p className="text-xl font-bold text-gray-900 dark:text-white">{label}</p>
            <p className="text-xs text-gray-500 dark:text-gray-400">Based on user reports</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};